<template>
    <el-dialog title="智能获取" :visible.sync="sysPicVisible" :append-to-body="true" width="710px" :before-close="handleClose"
        class="dialog_diy">
        <div>
            <div class="people_top_right" style="display: flex;align-items: center;">
                <div style="position: relative; width: 100%;">
                    <el-input style="height: 100%" placeholder="搜索图片关键字" v-model="searchImageValue"
                        @keyup.enter.native="resetImage()"></el-input>
                    <div class="search_img" @click="resetImage" style="right: 10px;">
                        <img src="../../../../../assets/icon/search.png" alt />
                    </div>
                </div>
                <el-button type="primary" size="default" style="margin-left: 10px;" @click="changePicture">换一组</el-button>
            </div>
            <div class="sysPicBox" v-loading="imageloading">
                <div class="picNone" v-if="!imageList.length">请输入关键词搜索图片</div>
                <div v-for="(sys, sysIndex) in imageList" :key="sysIndex" class="sysPic">
                    <img :src="sys.url" alt="" @click="chooseSysPic2(sys.url)" />
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        sysPicVisible: {
            type: Boolean,
        },
        value: {
            type: String,
            default: '' 
        }
    },
    data() {
        return {
            searchImageValue: "",
            imageloading: false,
            imageList: [],
            ppage: 1,
        }
    },
    methods: {
        handleClose(done) {
            this.close();
            done();
        },
        close() {
            this.$emit("update:sysPicVisible", false);
        },
        resetImage() {
            this.ppage = 1
            this.searchImage()
        },
        changePicture() {
            this.ppage++
            this.searchImage()
        },
        searchImage() {
            var _this = this;
            if (_this.searchImageValue == "") {
                _this.$message.error("请输入关键词");
                return
            }
            _this.imageList = []
            _this.imageloading = true
            _this.ajax.post('https://gpt.cocorobo.cn/search_image', {
                page: _this.ppage,
                pagesize: 9,
                query: _this.searchImageValue
            }).then(function (response) {
                // console.log(response.data.data);
                var data = response.data.FunctionResponse.result;
                for (var i = 0; i < data.length; i++) {
                    _this.imageList.push({ url: data[i].thumbnail })
                }
                _this.imageloading = false
            }).catch(function (error) {
                console.log(error);
            });
        },
        chooseSysPic2(url){
            this.$emit("setImg", url);
            this.close();
        }
    },
    watch: {
        sysPicVisible(newValue, oldValue) {
            if (newValue) {
                this.searchImageValue = JSON.parse(JSON.stringify(this.value));
                this.ppage = 1
                this.searchImage()
            }
        },
        value: {
            handler: function (newVal, oldVal) {
                this.searchImageValue = JSON.parse(JSON.stringify(newVal));
            },
            deep: true,
        },
    },
    mounted() {
        this.searchImageValue = JSON.parse(JSON.stringify(this.value));
    },
}
</script>

<style scoped>
.dialog_diy>>>.el-dialog__header {
    background: #3c3c3c !important;
    padding: 15px 20px;
}

.dialog_diy>>>.el-dialog__title {
    color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn {
    top: 19px;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

.dialog_diy>>>.el-dialog__body,
.dialog_diy>>>.el-dialog__footer {
    background: #fafafa;
}

.dialog_diy3>>>.el-dialog__body,
.dialog_diy3>>>.el-dialog__footer {
    background: #eee !important;
}

.dialog_diy3>>>.el-dialog__body {
    padding: 20px 20px;
}

.dialog_diyStage>>>.el-dialog__body {
    padding: 10px;
}

.people_top_right {
    height: 40px;
    margin-bottom: 10px;
}

.search_img {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.search_img>img {
    width: 100%;
    height: 100%;
}

.sysPicBox {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    height: 435px;
    overflow: auto;
    position: relative;
}

.picNone {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    width: fit-content;
    color: #9c9c9c;
}

.sysPic {
    width: 200px;
    height: 115px;
    margin: 0 20px 20px 0;
    cursor: pointer;
}

.sysPic>img,
.isSysPic>img,
.deletePic>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.isSysPic {
    width: 200px;
    height: 115px;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/EnglishVoice/component/component/gptImg.vue